import React from 'react'
import { InfoContainer, InfoWrapper, InfoRow, NumberFlex, TextWrapper,
  FirstNumber, Boldtitle,Number, Subtitle, Column2, ImgWrap, Img, Heading, Column3, Column1} from './HowtoElement'


import ImageOne from '../../../images/how1.png';
import ImageTwo from '../../../images/how2.png';
import ImageThree from '../../../images/how3.png';
import { useTranslation } from 'react-i18next'


function HowtoSection({lightBg, imgStart, darkText, id,}) {
  const {t} = useTranslation();

  return (
		<>
		<InfoContainer lightBg={lightBg} id={id}>
			<InfoWrapper>
        <InfoRow imgStart={imgStart}>
        <Heading>{t("console.how.head")}</Heading>
        
          <Column1>
          
            <ImgWrap>
              <Img src={ ImageOne } alt='' />
              <TextWrapper>
                <NumberFlex>
                  <Number><FirstNumber>0</FirstNumber>1</Number>
                  <div>
                  <Boldtitle>{t("console.how.bolddes")}</Boldtitle>	
                  <Subtitle darkText={darkText} >{t("console.how.description")}</Subtitle>	
                  </div>
                </NumberFlex>
              </TextWrapper>
            </ImgWrap>
          </Column1>
          <Column2>
            <ImgWrap>
                <Img src={ ImageTwo } alt='' />
                <TextWrapper>
                  <NumberFlex>
                    <Number><FirstNumber>0</FirstNumber>2</Number>
                    <div>
                    <Boldtitle>{t("console.how.bolddes2")}</Boldtitle>	
                    <Subtitle darkText={darkText} >{t("console.how.description2")}</Subtitle>	
                    </div>
                  </NumberFlex>
                </TextWrapper>
              </ImgWrap>
          </Column2>
          <Column3>
          <ImgWrap>
              <Img src={ ImageThree } alt='' />
              <TextWrapper>
              <NumberFlex>
                <Number><FirstNumber>0</FirstNumber>3</Number>
                <div>
                <Boldtitle>{t("console.how.bolddes3")}</Boldtitle>	
                <Subtitle darkText={darkText} >{t("console.how.description3")}</Subtitle>	
                </div>
              </NumberFlex> 	
              </TextWrapper>
              
            </ImgWrap>
          </Column3>
        </InfoRow>
        
			</InfoWrapper>
		</InfoContainer>	
		</>
	)
}

export default HowtoSection
